// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stockImageModal_modal__j9HOZ {
  max-width: 880px;
  max-height: 615px;
  justify-content: start; }
  .stockImageModal_modal__j9HOZ .stockImageModal_image__tRsnD {
    object-fit: cover;
    aspect-ratio: 11 /6; }
  .stockImageModal_modal__j9HOZ .stockImageModal_imageContainer__pg8R4 {
    width: inherit;
    height: inherit;
    background-repeat: no-repeat;
    background-position: center;
    background-color: #e0e0e0;
    background-size: contain;
    position: relative; }
    .stockImageModal_modal__j9HOZ .stockImageModal_imageContainer__pg8R4 .stockImageModal_camera__IvaEY {
      position: absolute;
      bottom: 15px;
      transform: translate(-50%, 0);
      left: 50%;
      width: 250px;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 31px; }
      .stockImageModal_modal__j9HOZ .stockImageModal_imageContainer__pg8R4 .stockImageModal_camera__IvaEY .stockImageModal_text__A\\+qBD {
        text-align: center;
        letter-spacing: 0.1px;
        color: var(--White);
        padding: 4px 15px;
        font-weight: 400;
        font-size: 14px;
        line-height: 24px; }

.stockImageModal_infoBlock__DcQYY {
  padding: 10px; }
  .stockImageModal_infoBlock__DcQYY .stockImageModal_header__QioDQ {
    display: flex;
    justify-content: space-between; }
    .stockImageModal_infoBlock__DcQYY .stockImageModal_header__QioDQ .stockImageModal_status__CWa9g {
      letter-spacing: 0.1px;
      color: var(--White);
      border-radius: 20px;
      padding: 4px 10px;
      font-weight: 400;
      font-size: 12px;
      line-height: 24px; }
    .stockImageModal_infoBlock__DcQYY .stockImageModal_header__QioDQ .stockImageModal_statusStock__Sk6Hl {
      background: var(--Green); }
    .stockImageModal_infoBlock__DcQYY .stockImageModal_header__QioDQ .stockImageModal_statusLowStock__5BNS6 {
      background: var(--StockOrange); }
    .stockImageModal_infoBlock__DcQYY .stockImageModal_header__QioDQ .stockImageModal_statusOutStock__ZpZ0i {
      background: var(--StockRed); }
  .stockImageModal_infoBlock__DcQYY .stockImageModal_operation__ux6jX {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 150%;
    color: var(--HightEmphasis);
    margin-bottom: 10px; }
  .stockImageModal_infoBlock__DcQYY .stockImageModal_wrapper__xxhUQ {
    display: flex;
    flex-direction: column;
    gap: 5px; }

.stockImageModal_subtitle__FKYqQ {
  font-weight: 400;
  font-size: 12px;
  line-height: 24px;
  color: var(--MediumEmphasis); }
  .stockImageModal_subtitle__FKYqQ .stockImageModal_value__n0Eav {
    font-weight: 500;
    color: var(--HightEmphasis); }

.stockImageModal_close__6lpdz {
  position: absolute;
  top: 0px;
  right: -40px;
  right: -45px;
  padding: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(33, 33, 33, 0.87);
  border-radius: 50%;
  opacity: 0.7;
  transition: all 0.4s ease-in-out;
  cursor: pointer; }
  .stockImageModal_close__6lpdz:hover {
    opacity: 1; }

.stockImageModal_prev__av1NJ {
  position: absolute;
  left: -45px;
  top: 49%;
  transition: all 0.4s;
  cursor: pointer;
  opacity: 0.8; }
  .stockImageModal_prev__av1NJ:hover {
    opacity: 1; }

.stockImageModal_next__xtuy8 {
  position: absolute;
  right: -45px;
  top: 49%;
  transition: all 0.4s;
  cursor: pointer;
  opacity: 0.8;
  transform: rotate(180deg); }
  .stockImageModal_next__xtuy8:hover {
    opacity: 1; }

.stockImageModal_scale__McbJs {
  position: absolute;
  bottom: 20px;
  right: 20px; }

.stockImageModal_fullimage__jwAa4 {
  width: 100vw;
  height: 100vh;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  background-color: #00000070;
  backdrop-filter: blur(5px);
  z-index: 5000; }
  .stockImageModal_fullimage_image__XRk27 {
    margin: 0 auto;
    width: 90%;
    height: 90%;
    position: relative; }
  .stockImageModal_fullimage_out__xoi1S {
    position: absolute;
    bottom: calc(5% + 20px);
    right: calc(5% + 20px); }
`, "",{"version":3,"sources":["webpack://./src/pages/inventory/components/StockImageModal/stockImageModal.module.scss","webpack://./src/styles/fonts.scss"],"names":[],"mappings":"AAGA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB,EAAA;EAHxB;IAMI,iBAAiB;IACjB,mBAAmB,EAAA;EAPvB;IAWI,cAAc;IACd,eAAe;IACf,4BAA4B;IAC5B,2BAA2B;IAC3B,yBAAyB;IACzB,wBAAwB;IACxB,kBAAkB,EAAA;IAjBtB;MAoBM,kBAAkB;MAClB,YAAY;MACZ,6BAA6B;MAC7B,SAAS;MACT,YAAY;MAEZ,8BAA8B;MAC9B,mBAAmB,EAAA;MA3BzB;QA8BQ,kBAAkB;QAClB,qBAAqB;QAErB,mBAAmB;QAEnB,iBAAiB;QCKvB,gBAAgB;QAChB,eAAe;QACf,iBAAiB,EAAA;;ADAnB;EACE,aAAa,EAAA;EADf;IAII,aAAa;IACb,8BAA8B,EAAA;IALlC;MAQM,qBAAqB;MACrB,mBAAmB;MACnB,mBAAmB;MACnB,iBAAiB;MCWrB,gBAAgB;MAChB,eAAe;MACf,iBAAiB,EAAA;IDxBnB;MAiBM,wBAAwB,EAAA;IAjB9B;MAqBM,8BAA8B,EAAA;IArBpC;MAyBM,2BAA2B,EAAA;EAzBjC;IA8BI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,mBAAmB,EAAA;EAnCvB;IAuCI,aAAa;IACb,sBAAsB;IACtB,QAAQ,EAAA;;AAIZ;ECvBE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EDuBjB,4BAA4B,EAAA;EAF9B;IAKI,gBAAgB;IAChB,2BAA2B,EAAA;;AAI/B;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,kBAAkB;EAClB,YAAY;EACZ,gCAAgC;EAChC,eAAe,EAAA;EAbjB;IAeI,UAAU,EAAA;;AAId;EACE,kBAAkB;EAClB,WAAU;EACV,QAAO;EACP,oBAAoB;EACpB,eAAe;EACf,YAAY,EAAA;EANd;IAQI,UAAU,EAAA;;AAId;EACE,kBAAkB;EAClB,YAAW;EACX,QAAO;EACP,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,yBAAyB,EAAA;EAP3B;IASI,UAAU,EAAA;;AAId;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW,EAAA;;AAEb;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,MAAM;EACN,OAAO;EACP,2BAA2B;EAC3B,0BAA0B;EAC1B,aAAa,EAAA;EAEb;IACE,cAAc;IACd,UAAU;IACV,WAAW;IACX,kBAAkB,EAAA;EAEpB;IACE,kBAAkB;IAClB,uBAAuB;IACvB,sBAAsB,EAAA","sourcesContent":["@import 'src/styles/media.scss';\n@import 'src/styles/fonts.scss';\n\n.modal {\n  max-width: 880px;\n  max-height: 615px;\n  justify-content: start;\n\n  .image {\n    object-fit: cover;\n    aspect-ratio: 11 /6;\n  }\n\n  .imageContainer {\n    width: inherit;\n    height: inherit;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-color: #e0e0e0;\n    background-size: contain;\n    position: relative;\n\n    .camera {\n      position: absolute;\n      bottom: 15px;\n      transform: translate(-50%, 0);\n      left: 50%;\n      width: 250px;\n\n      background: rgba(0, 0, 0, 0.5);\n      border-radius: 31px;\n\n      .text {\n        text-align: center;\n        letter-spacing: 0.1px;\n\n        color: var(--White);\n\n        padding: 4px 15px;\n        @include body2;\n      }\n    }\n  }\n}\n\n.infoBlock {\n  padding: 10px;\n\n  .header {\n    display: flex;\n    justify-content: space-between;\n\n    .status {\n      letter-spacing: 0.1px;\n      color: var(--White);\n      border-radius: 20px;\n      padding: 4px 10px;\n\n      @include caption;\n    }\n\n    .statusStock {\n      background: var(--Green);\n    }\n\n    .statusLowStock {\n      background: var(--StockOrange);\n    }\n\n    .statusOutStock {\n      background: var(--StockRed);\n    }\n  }\n\n  .operation {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 150%;\n    color: var(--HightEmphasis);\n    margin-bottom: 10px;\n  }\n\n  .wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n  }\n}\n\n.subtitle {\n  @include caption;\n  color: var(--MediumEmphasis);\n\n  .value {\n    font-weight: 500;\n    color: var(--HightEmphasis);\n  }\n}\n\n.close {\n  position: absolute;\n  top: 0px;\n  right: -40px;\n  right: -45px;\n  padding: 11px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(33, 33, 33, 0.87);\n  border-radius: 50%;\n  opacity: 0.7;\n  transition: all 0.4s ease-in-out;\n  cursor: pointer;\n  &:hover {\n    opacity: 1;\n  }\n}\n\n.prev{\n  position: absolute;\n  left:-45px;\n  top:49%;\n  transition: all 0.4s;\n  cursor: pointer;\n  opacity: 0.8;\n  &:hover{\n    opacity: 1;\n  }\n}\n\n.next{\n  position: absolute;\n  right:-45px;\n  top:49%;\n  transition: all 0.4s;\n  cursor: pointer;\n  opacity: 0.8;\n  transform: rotate(180deg);\n  &:hover{\n    opacity: 1;\n  }\n}\n\n.scale {\n  position: absolute;\n  bottom: 20px;\n  right: 20px;\n}\n.fullimage {\n  width: 100vw;\n  height: 100vh;\n  position: fixed;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  top: 0;\n  left: 0;\n  background-color: #00000070;\n  backdrop-filter: blur(5px);\n  z-index: 5000;\n\n  &_image {\n    margin: 0 auto;\n    width: 90%;\n    height: 90%;\n    position: relative;\n  }\n  &_out {\n    position: absolute;\n    bottom: calc(5% + 20px);\n    right: calc(5% + 20px);\n  }\n}\n","@mixin h1 {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 150%;\n}\n\n@mixin h2 {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 150%;\n}\n\n@mixin h3 {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n}\n\n@mixin h4 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin h5 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin h6 {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin body1 {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin body2 {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n@mixin body3 {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n}\n\n@mixin link1 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin link2 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin caption {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 24px;\n}\n\n@mixin title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin button {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `stockImageModal_modal__j9HOZ`,
	"image": `stockImageModal_image__tRsnD`,
	"imageContainer": `stockImageModal_imageContainer__pg8R4`,
	"camera": `stockImageModal_camera__IvaEY`,
	"text": `stockImageModal_text__A+qBD`,
	"infoBlock": `stockImageModal_infoBlock__DcQYY`,
	"header": `stockImageModal_header__QioDQ`,
	"status": `stockImageModal_status__CWa9g`,
	"statusStock": `stockImageModal_statusStock__Sk6Hl`,
	"statusLowStock": `stockImageModal_statusLowStock__5BNS6`,
	"statusOutStock": `stockImageModal_statusOutStock__ZpZ0i`,
	"operation": `stockImageModal_operation__ux6jX`,
	"wrapper": `stockImageModal_wrapper__xxhUQ`,
	"subtitle": `stockImageModal_subtitle__FKYqQ`,
	"value": `stockImageModal_value__n0Eav`,
	"close": `stockImageModal_close__6lpdz`,
	"prev": `stockImageModal_prev__av1NJ`,
	"next": `stockImageModal_next__xtuy8`,
	"scale": `stockImageModal_scale__McbJs`,
	"fullimage": `stockImageModal_fullimage__jwAa4`,
	"fullimage_image": `stockImageModal_fullimage_image__XRk27`,
	"fullimage_out": `stockImageModal_fullimage_out__xoi1S`
};
export default ___CSS_LOADER_EXPORT___;
